import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Lab|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryLab';
export type SPCandidateHistoryLabLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelUpdated`
	| `${LocNameStart}LabelReviewStatus`
	| `${LocNameStart}LabelInvalid`
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelDocumentation`;

export const spCandidateHistoryLabLocs: LocDefs<SPCandidateHistoryLabLocNames> = {
	SPCandidateHistoryLabTitlePage: {
		defaultValue: 'Labs',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Candidates.Labs.Title.PageSectionTitle',
		...sharedProperties,
	},
	SPCandidateHistoryLabTitleTab: {
		defaultValue: 'Labs',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Candidates.Labs.Title.Tab',
		...sharedProperties,
	},
	SPCandidateHistoryLabLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Labs.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCandidateHistoryLabLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Column heading for: Active Date.',
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Labs.ColumnHeading.ActiveDate',
		...sharedProperties,
	},
	SPCandidateHistoryLabLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Column heading for: Expire Date.',
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Labs.ColumnHeading.ExpireDate',
		...sharedProperties,
	},
	SPCandidateHistoryLabLabelUpdated: {
		defaultValue: 'Updated',
		description: 'Column heading for: Updated.',
		displayPath: `${pathStart}Updated`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Labs.ColumnHeading.Updated',
		...sharedProperties,
	},
	SPCandidateHistoryLabLabelReviewStatus: {
		defaultValue: 'Review Status',
		description: 'Column heading for: Review Status.',
		displayPath: `${pathStart}Review Status`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Labs.ColumnHeading.ReviewStatus',
		...sharedProperties,
	},
	SPCandidateHistoryLabLabelInvalid: {
		defaultValue: 'Invalid',
		description: 'Column heading for: Invalid.',
		displayPath: `${pathStart}Invalid`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Labs.ColumnHeading.Invalid',
		...sharedProperties,
	},
	SPCandidateHistoryLabLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: 'Column heading for: Data Provider.',
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Labs.ColumnHeading.DataProvider',
		...sharedProperties,
	},
	SPCandidateHistoryLabLabelDocumentation: {
		defaultValue: 'Documentation',
		description: 'Column heading for: Documentation.',
		displayPath: `${pathStart}Documentation`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Labs.ColumnHeading.Documentation',
		...sharedProperties,
	},
};

export type SPCandidateHistoryLabLocType = LocMap<SPCandidateHistoryLabLocNames>;
